import 'css-chunksrc/client/pages/zonesPage/zonesPage/placeholder/styles.scss';export default {
  "placeholder": "_placeholder_1q34a_1",
  "button": "_button_1q34a_22"
};